import styled from 'styled-components';

import { EM_DASH } from 'components/insights/formatting';
import Card from 'components/insights/layout/Card';
import CircularProgress from 'components/shared/CircularProgress';
import { colors } from 'styles/theme/colors';

type Props = {
  label: string;
  value?: string;
  loading: boolean;
};

export default function StatCard({ label, value, loading }: Props) {
  return (
    <CompactCard>
      <Label>{label}</Label>
      <Value>{loading ? <CircularProgress color={colors.blue100} size={24} /> : (value ?? EM_DASH)}</Value>
    </CompactCard>
  );
}

const CompactCard = styled(Card)`
  padding: 20px 24px;
`;

const Label = styled.div`
  color: ${({ theme }) => theme.colors.black100};
  font-size: 12px;
  font-weight: normal;
`;

const Value = styled.div`
  color: ${({ theme }) => theme.colors.black100};
  font-size: 24px;
  font-weight: 900;
  margin-top: 8px;
  min-height: 24px;
`;
